import { useUserDataContext } from "contexts/UserDataContext/UserDataContext";
import {
    PlatformAction,
    useSetPlatformActions
} from "infrastructure/platform/PlatformShellContext";
import { useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { getRedirectUrl, IN_QUEUE_COMMON_DOCS_SPACE } from "types/gitBook";
import {
    segmentTrackClickDocumentation,
    segmentTrackClickSearchButton
} from "./analytics";
import { useSearchPalette } from "./components/SearchPalette/SearchPaletteContext";

export const InQueueNavActions: React.FC = () => {
    const user = useUserDataContext();
    const setActions = useSetPlatformActions();
    const { open: openSearch } = useSearchPalette();
    const { pathname } = useLocation();
    const docsLink = getRedirectUrl(IN_QUEUE_COMMON_DOCS_SPACE, null, user);

    const actions: ReadonlyArray<PlatformAction> = useMemo(
        () => [
            {
                icon: "search",
                label: "Search",
                onClick: () => {
                    segmentTrackClickSearchButton({ pagePath: pathname });
                    openSearch();
                }
            },
            {
                icon: "manual",
                label: "Documentation",
                disabled: docsLink === undefined,
                onClick: () => {
                    if (docsLink !== undefined) {
                        segmentTrackClickDocumentation({
                            pagePath: pathname,
                            source: "nav"
                        });
                        window.open(docsLink, "_blank");
                    }
                }
            }
        ],
        [openSearch, docsLink, pathname]
    );

    useEffect(() => {
        setActions(actions);
        return () => setActions([]);
    }, [setActions, actions]);

    return null;
};
